import marked from 'marked';

export enum FAQ_CONTENTFUL {
  city = 'city/nachhilfe',
  subject = 'online-nachhilfe/subject',
}

export type FAQ_META = {
  question: string;
  answer: any;
};

export type FAQ_LIST = {
  path: string;
  faq: FAQ_META[];
};

export const getFAQ = (
  faqList: FAQ_LIST[],
  type: FAQ_CONTENTFUL,
  value: string | undefined | null
) => {
  if (value) {
    const result = faqList.find((node: any) => {
      return node.path === type;
    });
    const finalFAQ = result?.faq.map(({ question, answer }) => {
      return {
        question: transformAnswerToHtml(question, type, value),
        answer: transformAnswerToHtml(answer.answer, type, value),
      };
    });
    return finalFAQ ? convertToMeta(finalFAQ) : '';
  }
};

const transformAnswerToHtml = (answer: string, type: FAQ_CONTENTFUL, value: string) => {
  const markedAnswer = marked(answer);
  const clearAnswer = markedAnswer.replace(/"/g, "'");
  switch (type) {
    case FAQ_CONTENTFUL.subject:
      return clearAnswer.replace(/{{subject}}/g, value);
    case FAQ_CONTENTFUL.city:
      return clearAnswer.replace(/{{city}}/g, value);
  }
};

const convertToMeta = (faq: FAQ_META[]) => {
  const faq_json = faq.map(
    ({ question, answer }) =>
      `{
          "@type": "Question",
          "name": "${question}",
          "acceptedAnswer": {  
              "@type": "Answer",  
              "text": "${answer}"
            }
        }`
  );
  return `{
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [${faq_json.join(',')}]
  }`;
};
